import { UnexpectedError } from '../../domain/errors/unexpected-error'
import { AccessDeniedError } from '../../domain/errors/access-denied-error'
import { UnauthorizedError } from '../../domain/errors/unauthorized-error'
import { UnprocessableEntityError } from '../../domain/errors/unprocessable-entity-error'

const isHttpError = (error: unknown) => {
  if (
    error instanceof UnexpectedError
    || error instanceof UnauthorizedError
    || error instanceof AccessDeniedError
    || error instanceof UnprocessableEntityError
  ) {
    return error
  }
  return null
}

export default isHttpError
